import SyncHook from './simple-hooks';
import { WUJI_DEPS_KEY } from './consts';
import NpmLoader from './loader/npm-loader';
import CdnLoader from './loader/cdn-loader';
import eventBus, { EVENT } from '@utils/event-bus';
import { isEqual } from 'lodash';
window[WUJI_DEPS_KEY] = {};
// 白名单里的依赖不走npm加载，而是走cdn加载，因为像echarts这种依赖通过它加载的速度比npm下载的速度快很多
const WHITE_LIST = ['echarts'];
class DependencyLoader {
    // hook是为了当编辑器加载新的依赖时，通知预览中的页面也加载对应的依赖
    hooks = {
        load: new SyncHook(),
        register: new SyncHook(),
    };
    bundle = {
        js: '',
        css: '',
    };
    stateCallBacks = [];
    loadCallbacks = [];
    registeredModules = new Set();
    npmLoader = null;
    cdnLoader = null;
    constructor() {
        if (window[WUJI_DEPS_KEY])
            return;
        window[WUJI_DEPS_KEY] = {};
    }
    onProgress(callback) {
        this.stateCallBacks.push(callback);
    }
    offProgress(callback) {
        this.stateCallBacks = this.stateCallBacks.filter(i => i !== callback);
    }
    onLoad(callback) {
        this.loadCallbacks.push(callback);
    }
    offLoad(callbackToDelete) {
        this.loadCallbacks = this.loadCallbacks.filter(callback => callback !== callbackToDelete);
    }
    emitProgress(progress) {
        this.stateCallBacks.forEach((callback) => {
            callback(progress);
        });
    }
    emitLoad(initParams) {
        this.loadCallbacks.forEach((callback) => {
            callback(initParams);
        });
    }
    getPreviewDepInfo() {
        const { bundleFile: bundle, packageJson, presets } = this.npmLoader;
        return {
            dependencies: Array.from(this.registeredModules),
            packageJson,
            bundle,
            presets,
        };
    }
    async updatePreviewDeps({ dependencies, bundle, }) {
        // 用于更新预览页中的依赖
        // 注意这里的bundle和init的bundle不一样，这里的是可以直接执行的代码, 而不是CDN地址
        // 所以我们用的是executeBundle函数
        const cdnLoadModules = dependencies.filter(i => WHITE_LIST.includes(i));
        await Promise.all([
            this.npmLoader.executeBundle(bundle),
            this.cdnLoader.load(cdnLoadModules),
        ]);
    }
    ;
    async init({ dependencies, bundle, packageJson, presets, }) {
        eventBus.on(EVENT.updateDepLoaderState, (progress) => {
            this.emitProgress(progress);
        });
        this.npmLoader = this.npmLoader || new NpmLoader();
        this.cdnLoader = this.cdnLoader || new CdnLoader();
        const cdnLoadModules = dependencies.filter(i => WHITE_LIST.includes(i));
        const npmLoadModules = dependencies.filter(i => !WHITE_LIST.includes(i));
        this.bundle = bundle;
        await Promise.all([
            this.npmLoader.init(bundle, npmLoadModules, packageJson, presets),
            this.cdnLoader.load(cdnLoadModules),
        ]);
    }
    // 在编辑器运行的过程中，通过这个方法注册依赖
    register(module) {
        this.registeredModules.add(module);
        if (WHITE_LIST.includes(module)) {
            this.cdnLoader.register(module);
        }
    }
    async load(dependencies) {
        const npmLoadModules = dependencies.filter(i => !WHITE_LIST.includes(i));
        const cdnLoadModules = dependencies.filter(i => WHITE_LIST.includes(i));
        await Promise.all([this.npmLoader.load(npmLoadModules), this.cdnLoader.load(cdnLoadModules)]);
        const { bundleFile: bundle, packageJson, presets } = this.npmLoader;
        this.hooks.load.call(dependencies);
        dependencies.forEach((module) => {
            this.registeredModules.add(module);
        });
        this.emitLoad({
            dependencies: Array.from(this.registeredModules),
            packageJson,
            bundle,
            presets,
        });
    }
    /**
     * packageJSON变化触发的更新，用于依赖版本更新的情况
     * @param finalDependencies
     * @param newPacakgeJson
     * @returns
     */
    async updateWithPackageJson(finalDependencies, newPacakgeJson) {
        const npmLoadModules = finalDependencies.filter(i => !WHITE_LIST.includes(i));
        return this.npmLoader.update(npmLoadModules, newPacakgeJson);
    }
    /**
     * 清空node_module和package.json后重新下载，生成最新的bundle和packageJson
     *
     * 用户点击页面保存后会可能执行，确保bundle和packageJson里没有多余的依赖
     * @param finalDependencies
     */
    async update(finalDependencies) {
        const { bundleFile: bundle, presets, packageJson } = this.npmLoader;
        // 如果已经生成过bundle，则对比依赖是否一致
        if (this.hasBundled()) {
            window[WUJI_DEPS_KEY] = {};
            await this.npmLoader?.executeBundle(bundle);
            await this.cdnLoader?.load(finalDependencies.filter(i => WHITE_LIST.includes(i)));
            const currentDependencies = Object.keys(window[WUJI_DEPS_KEY]);
            if (isEqual(finalDependencies.sort(), currentDependencies.sort())) {
                return {
                    bundle,
                    packageJson,
                    presets,
                };
            }
        }
        // 如果当前的bundle不包含所有的依赖，则重新下载依赖
        const npmLoadModules = finalDependencies.filter(i => !WHITE_LIST.includes(i));
        return this.npmLoader.update(npmLoadModules);
    }
    async updateVersion(packageJson) {
        return this.npmLoader.updateVersion(packageJson);
    }
    /**
     * 是否触发过bundle
     * @returns Boolean
     */
    hasBundled() {
        return Boolean(this.npmLoader?.bundleFile?.js || this.npmLoader?.bundleFile?.css);
    }
    debug(moduleName) {
        this.npmLoader.debug(moduleName);
    }
}
const dependencyLoader = new DependencyLoader();
window.wuji_dependency_loader = dependencyLoader;
export default dependencyLoader;
